import { render, staticRenderFns } from "./SeguroSaludHNAServicios.vue?vue&type=template&id=cdf9dd5a&scoped=true&"
import script from "./SeguroSaludHNAServicios.vue?vue&type=script&lang=js&"
export * from "./SeguroSaludHNAServicios.vue?vue&type=script&lang=js&"
import style0 from "./SeguroSaludHNAServicios.vue?vue&type=style&index=0&id=cdf9dd5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf9dd5a",
  null
  
)

export default component.exports